import { useState, useEffect } from 'react';
import { httpsCallable } from 'firebase/functions';
import { auth, functions } from '../firebase';
import './HoneymoonFund.css';

const ACCOUNT_NAME = 'Catherine Sellick & Oliver Binns';

function BankDetailRow({ label, value, field, copied, onCopy }) {
  return (
    <div className="bank-detail-row">
      <span className="bank-detail-label">{label}</span>
      <span className="bank-detail-value">{value}</span>
      <button
        className={`copy-button${copied === field ? ' copied' : ''}`}
        onClick={() => onCopy(value, field)}
        aria-label={`Copy ${label}`}
      >
        {copied === field ? 'Copied!' : 'Copy'}
      </button>
    </div>
  );
}

function HoneymoonFund() {
  const [bankDetails, setBankDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [copied, setCopied] = useState(null);

  useEffect(() => {
    const user = auth.currentUser;
    if (!user) {
      setLoading(false);
      return;
    }

    const getBankDetails = httpsCallable(functions, 'bankDetails');
    getBankDetails()
      .then((result) => {
        setBankDetails(result.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Failed to fetch bank details:', err);
        setError(true);
        setLoading(false);
      });
  }, []);

  function copyToClipboard(text, field) {
    navigator.clipboard.writeText(text)
      .then(() => {
        setCopied(field);
        setTimeout(() => setCopied(null), 2000);
      })
      .catch((err) => {
        console.error('Failed to copy to clipboard:', err);
      });
  }

  return (
    <div className="content invite">
      <h2 className="josefin-slab upper">Wedding Gifts</h2>
      <p className="josefin-slab">
        The most important gift to us is your presence on our special day, but if you do wish to
        contribute in another way, we&apos;d love a few pennies to put towards our honeymoon trip
        after tying the knot.
      </p>

      {loading && (
        <p className="josefin-slab">Loading bank details&hellip;</p>
      )}

      {error && (
        <p className="josefin-slab">
          Bank details are currently unavailable. Please try again later.
        </p>
      )}

      {!loading && !error && bankDetails && (
        <div className="bank-details">
          <div className="payment-or-separator">
            <span>Bank Details</span>
          </div>
          <BankDetailRow
            label="Account Name"
            value={ACCOUNT_NAME}
            field="accountName"
            copied={copied}
            onCopy={copyToClipboard}
          />
          <BankDetailRow
            label="Sort Code"
            value={bankDetails.sortCode}
            field="sortCode"
            copied={copied}
            onCopy={copyToClipboard}
          />
          <BankDetailRow
            label="Account Number"
            value={bankDetails.accountNumber}
            field="accountNumber"
            copied={copied}
            onCopy={copyToClipboard}
          />

          {bankDetails.monzoLink && (
            <>
              <div className="payment-or-separator">
                <span>or</span>
              </div>
              <a
                href={bankDetails.monzoLink}
                className="monzo-button"
                target="_blank"
                rel="noopener noreferrer"
              >
                Gift using Card Payment
              </a>
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default HoneymoonFund;
